module.exports = __webpack_public_path__ + "static/img/1000000438.5214277d.jpg";